import React, { useMemo, useState } from "react";
import { Typography } from "@mui/material";
import { parsePhoneNumber } from "libphonenumber-js";
import { Form } from "react-final-form";
import { Text } from "../../../../common/components/input/Text";
import { makeStyles } from "@mui/styles";
import { Check, Error } from "@mui/icons-material";
import { LoadingButton } from "../../../../common/components/LoadingButton";

const useStyles = makeStyles({
  wrongCode: {
    fontSize: "11px",
    width: "120px",
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  newCodeSent: {
    fontSize: "11px",
    width: "120px",
    display: "flex",
    gap: "10px",
    marginTop: "10px",
  },
  disclaimerIcon: {
    fontSize: "24px",
  },
});

export const MultiFactorAuthSetupComplete = ({
  phone,
  resendCode,
  validateMfaCode,
  wrongCodeError,
  isLoading,
}: {
  phone: string;
  resendCode: () => void;
  validateMfaCode: (code: string) => Promise<void>;
  wrongCodeError: boolean;
  isLoading: boolean;
}) => {
  const [codeResent, setCodeResent] = useState(false);
  const displayNumber = useMemo(() => {
    if (phone) {
      const num = parsePhoneNumber(phone, "US");
      if (num) {
        return `+${num.countryCallingCode}-***-***-${num.nationalNumber.slice(-4)}`;
      }
    }
    return "the phone number you provided";
  }, [phone]);
  const classes = useStyles();

  return (
    <>
      <p className="text-center fill mt-sm mb-lg">
        Confirm your account by entering the authentication code sent to {displayNumber}.
      </p>
      <Form
        onSubmit={async (values) => {
          validateMfaCode(values.code);
        }}
        render={(props) => (
          <form className="flex-col fill" onSubmit={props.handleSubmit}>
            <div className="flex-col fill">
              <div className="flex-row flex--expand mb-xxs">
                <div className="p-relative">
                  <Text
                    className="m-0 w-300"
                    fullWidth={false}
                    multiline={false}
                    variant="outlined"
                    name="code"
                    field="code"
                    inputMode="numeric"
                    size="small"
                    autoComplete="one-time-code"
                    required
                  />
                  {wrongCodeError && (
                    <Typography color="error" className={classes.wrongCode}>
                      <Error color="error" className={classes.disclaimerIcon} />
                      Incorrect code, please try again
                    </Typography>
                  )}
                  {!wrongCodeError && codeResent && (
                    <Typography color="green" className={classes.newCodeSent}>
                      <Check color="success" className={classes.disclaimerIcon} />
                      New code sent
                    </Typography>
                  )}
                </div>
              </div>
              <div className="fill mb-xxs">
                <Typography fontSize="small" className="my-0 w-300 text-right">
                  Didn't get it?&nbsp;
                  <a
                    href="#"
                    onClick={() => {
                      resendCode();
                      setCodeResent(true);
                    }}
                  >
                    Resend Code
                  </a>
                </Typography>
              </div>
              <div className="flex-row flex--expand" style={{ marginTop: "12px" }}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  size="large"
                  className="text-transform-none w-300"
                  disabled={!/^[0-9]{6}$/.test(props.values?.code)}
                  onClick={props.handleSubmit}
                  loading={isLoading}
                  type="submit"
                >
                  Submit
                </LoadingButton>
              </div>
            </div>
          </form>
        )}
      />
    </>
  );
};
